import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { setDocumentType } from "../reducer/selfCheckinSlice";
import heic2any from "heic2any";
// import uploadedimg from "../assets/images/adhar-card.png";
// import { InnPreviewImage } from "./innPreviewImage";

export function InnFileUpload(props) {
  const inputFile = useRef(null);

  const [FilePath, setFilePath] = useState("");
  const [previewModal, setpreviewModal] = useState(false);
  const dispatch = useDispatch();

  let base64string = "";

  useEffect(() => {
    if (FilePath != props.src) {
      setFilePath(props.src);
    }
  }, [props.src]);

  //For open uploader,file selection dialog box
  const onFileClick = () => {
    inputFile.current.click();
  };

  //File Change
  const handleChange = async (e) => {
    let file = e.target.files[0];
    // console.log("Load File or Pdf :: ", file?.type);
    // console.log("Load File or Pdf :: ", file?.name.includes(".heic"));
    // console.log("Load File or Pdf :: ", file);
    if (file?.name.includes(".heic")) {
      await heic2any({ blob: file })
        .then((res) => {
          let imgType = "png";
          var reader1 = new FileReader();
          reader1.readAsDataURL(res);
          reader1.onloadend = function () {
            var base64data = reader1.result;
            // console.log("base64", base64data);
            if (base64data.includes("image/jpeg")) {
              imgType = "image/jpeg";
            }
            if (base64data.includes("image/png")) {
              imgType = "image/png";
            }
            if (base64data.includes("image/jpg")) {
              imgType = "image/jpg";
            }

            dispatch(setDocumentType(imgType))
            base64string = reader1.result.replace("data:", "").replace(/^.+,/, "");
            setFilePath(
              "data:'" + imgType + "';base64," + base64string
            );
            //file obj
            let obj = {
              fname: e.target.files[0].name,
              fpath: "data:'" + imgType + "';base64," + base64string,
              // fpath: base64string,

            };
            if (props.onChange) {
              props.onChange(obj);
            }
          }
        })
    }
    else {
      dispatch(setDocumentType(file?.type))
      if (file) {
        let reader = new FileReader();
        reader.onload = () => {
          // console.log(reader.result)
          base64string = reader.result.replace("data:", "").replace(/^.+,/, "");
          setFilePath(
            "data:'" + e.target.files[0].type + "';base64," + base64string
          );
          //file obj
          let obj = {
            fname: e.target.files[0].name,
            fpath: "data:'" + e.target.files[0].type + "';base64," + base64string,
            // fpath: base64string,

          };
          if (props.onChange) {
            props.onChange(obj);
          }
        };
        reader.readAsDataURL(file);
      }
    }
  };

  //For Close Button Click Event
  const handlClick = (e) => {
    e.stopPropagation();
    setFilePath("");
    inputFile.current.value = "";
  };

  //For Preview Button Click Event
  const handlePreviewBtn = (e) => {
    e.stopPropagation();
    setpreviewModal(true);
  };

  return (
    // <div className="form-group mrgn-tp20">
    <div
    // className={
    //   props.disabled == true
    //     ? "form-group disabled " + props.className
    //     : "form-group " + props.className
    // }
    >
      <div className="photo-upload-preview">
        {/* <div className="photo-lbl">
          <span>{props.children}</span>
          {props.customError != undefined && props.customError != "" ? (
            <div class="error">
              <span>{props.customError}</span>
            </div>
          ) : (
            <></>
          )}
        </div> */}
        <div className="upload-preview">
          <div className="uploaded-image" onClick={onFileClick}>
            {FilePath !== "" ? (
              <div>
                <img src={FilePath} />
                <div className="photo-lbl">Upload Photo</div>
                {/*  <button
                  className="remove-img-btn"
                  onClick={handlClick}
                ></button> */}
                {/* <button className="preview-btn" onClick={handlePreviewBtn}>
                  Preview
                </button> */}
              </div>
            ) : (
              <></>
            )}
          </div>
          <input
            type="file"
            id="file"
            ref={inputFile}
            style={{ display: "none" }}
            onChange={handleChange}
            disabled={props.disabled}
          />
        </div>
        <div className="photo-lbl">
          <span>{props.children}</span>
          {props.customError != undefined && props.customError != "" ? (
            <div class="error">
              <span>{props.customError}</span>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
      {/* <div>
        {previewModal == true ? (
          <InnPreviewImage
            className="large-popup"
            Onclose={() => setpreviewModal(false)}
          >
            <div className="text-center pdng-20">
              <img src={FilePath} width="600px" height="400px" />
            </div>
          </InnPreviewImage>
        ) : (
          ""
        )}
      </div> */}
    </div>
  );
}
